import { render, staticRenderFns } from "./AutocompleteSearch.vue?vue&type=template&id=552dfa62"
import script from "./AutocompleteSearch.vue?vue&type=script&lang=js"
export * from "./AutocompleteSearch.vue?vue&type=script&lang=js"
import style0 from "./AutocompleteSearch.vue?vue&type=style&index=0&id=552dfa62&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports